import { OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import { take, sortBy } from 'lib/array/arrayUtils'

type TopNFilterItem = [string, number, number]

function getFiltersWithMinimumCount(minimumCount: number, filters: Record<string, number>) {
  return Object.entries(filters).filter(([_, count]) => (count >= minimumCount))
}

// using the filter order, get the most selected filters but only if there is a minimum number of hotels for that filter.
export function getHotelFiltersByFilterOrderAndCount(
  filters: Record<string, number> | undefined, // the filters are the filter names alongside their hotel count.
  filterOrders: Record<string, number> = {}, // the filter order is essentially the filters ordered by the largest number of clicks on that filter.
  topN: number, // once filtered and sorted, return the top N filters.
  minimumCount?: number, // the minimum count is the smallest number of offers related to a filter for that filter to not be excluded for the final list.
): string[] | undefined {
  if (!filters) {
    return undefined
  }
  const updatedFilters = minimumCount ? getFiltersWithMinimumCount(3, filters) : Object.entries(filters)
  const options: TopNFilterItem[] = updatedFilters.map(([filterName, filterHotelCount]) => ([filterName, filterHotelCount, filterOrders[filterName] ?? 0]))
  const sortedOptions = take(sortBy(options, (option) => option[2], 'desc'), topN)
  return sortedOptions.map(([name]) => (name))
}

export const OFFER_TYPES: App.OfferListOfferType[] = [OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_LAST_MINUTE]
